export function normalizePhone(raw: string): string | null {
  let d = (raw || "").replace(/\D/g, "");
  if (d.length === 11 && d.startsWith("7")) d = "8" + d.slice(1);
  else if (d.length === 10) d = "8" + d;
  if (d.length === 11 && d.startsWith("8")) return d;
  return null;
}
